import React, { useState } from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import expand from '../images/svgs/expand-icon-gray.svg'

export default function ImageModal({ file }) {
    const [show, setShow] = useState(false)
    if(file) return (
        <>
            <Button variant='' className='position-absolute top-0 end-0 p-3' onClick={() => setShow(true)}>
                <img src={expand} alt='' />
            </Button>
            <Modal show={show} fullscreen onHide={() => setShow(false)}>
                <Modal.Header closeButton />
                <Modal.Body className='text-center'>
                    <GatsbyImage image={getImage(file)} alt='' />
                </Modal.Body>
            </Modal>
        </>
    )
}
